var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{ 'loading-block': _vm.type == 'block' }},[_c('div',{staticClass:"icon"},[_vm._v("")]),_c('div',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }